import React from 'react';
import './Cart.css'

const CartItem = ({item,value}) => {
    const{id,title,image,price,total,count} = item;
    const{increment, decrement,removeItem} = value;
    return (
        <div>
            <div className="row my-5 align-items-center text-center">
                <div className="col-10 mx-auto col-lg-2 align-items-center">
                    <img src={image} alt=""
                    style={{width:"7rem",}} 
                    className="img-fluid"/> 
                </div>
                <div className="col-10 mx-auto col-lg-2">
                    <h4 className="my-auto" >{title}</h4>
                </div>
                <div className="col-10 mx-auto col-lg-2">
                    <h5 className="my-auto" >${price}.00</h5>
                </div>
                <div className="col-10 mx-auto col-lg-2 my-2 my-lg-0">
                    <div className="d-flex justify-content-center">
                        <span className="btn btn-blue mx-1" onClick={()=>decrement(id)}>-</span>
                        <span className="btn btn-blue mx-1">{count}</span>
                        <span className="btn btn-blue mx-1" onClick={()=>increment(id)}>+</span>
                    </div>
                </div>
                <div className="col-10 mx-auto col-lg-2">
                    <div className="cart-icon" onClick={()=>removeItem(id)}>
                        <i class="fas fa-trash"></i>    
                    </div>
                </div>
                <div className="col-10 col-lg-2">
                    <h5 className="my-auto" >${total}.00</h5>
                </div>
            </div>
        </div>
    );
}

export default CartItem;
